import * as React from 'react';
import './Loading.scss';

const DownloadingPanel = () => (
    <div id="downloading-panel">
        <div id="downloading-indicator">
            <div className="dissolve-cube">
                <div className="cube-section cube-section1 tier-3"/>
                <div className="cube-section cube-section2 tier-4"/>
                <div className="cube-section cube-section3 tier-5"/>
                <div className="cube-section cube-section4 tier-2"/>
                <div className="cube-section cube-section5 tier-3"/>
                <div className="cube-section cube-section6 tier-4"/>
                <div className="cube-section cube-section7 tier-1"/>
                <div className="cube-section cube-section8 tier-2"/>
                <div className="cube-section cube-section9 tier-3"/>
            </div>
            <p>downloading</p>
        </div>
    </div>
);

export { DownloadingPanel };
